export default function(state = [], action) {
  switch (action.type) {
    case 'SET_INVITATIONS':
      return action.invitations
    default:
      return state
  }
}
